/**
 * Owlbert illustrations (sketch style, shared with the emails). SVGs live in /public/illustrations
 * and are generated by scripts/design/owlbert-illustrations.js. See scripts/design/DESIGN_SYSTEM.md.
 */
export type IllustrationName =
  | "owl-wave" | "owl-rocket" | "owl-search" | "owl-lock" | "owl-trophy" | "owl-phone"
  | "owl-megaphone" | "owl-cap" | "owl-sleepy" | "owl-book" | "owl-chart" | "owl-cheer";

const ALT: Record<IllustrationName, string> = {
  "owl-wave": "Owlbert waving", "owl-rocket": "Owlbert on a rocket", "owl-search": "Owlbert looking with a magnifying glass",
  "owl-lock": "Owlbert next to a padlock", "owl-trophy": "Owlbert with a trophy", "owl-phone": "Owlbert with a phone",
  "owl-megaphone": "Owlbert with a megaphone", "owl-cap": "Owlbert in a graduation cap", "owl-sleepy": "Owlbert dozing",
  "owl-book": "Owlbert with an open book", "owl-chart": "Owlbert with a rising chart", "owl-cheer": "Owlbert cheering",
};

export function Illustration({ name, size = 120, className = "", decorative = true }: { name: IllustrationName; size?: number; className?: string; decorative?: boolean }) {
  return (
    <img
      src={`/illustrations/${name}.svg`}
      alt={decorative ? "" : ALT[name]}
      aria-hidden={decorative ? true : undefined}
      width={size}
      height={size}
      className={`inline-block select-none pointer-events-none ${className}`}
      style={{ width: size, height: "auto", maxWidth: "100%" }}
      draggable={false}
    />
  );
}
